import { render, staticRenderFns } from "./ClientSettingEdit.vue?vue&type=template&id=6096f23b&scoped=true"
import script from "./ClientSettingEdit.vue?vue&type=script&lang=js"
export * from "./ClientSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientSettingEdit.vue?vue&type=style&index=0&id=6096f23b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096f23b",
  null
  
)

export default component.exports